import { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import api from '@/lib/api';

export default function WhatsAppButton() {
    const [number, setNumber] = useState('07050657701');

    useEffect(() => {
        api.get('/settings').then(({ data }) => {
            if (data.whatsapp_number) setNumber(data.whatsapp_number);
        }).catch(() => {});
    }, []);

    const cleanNumber = number.replace(/\D/g, '');
    const intlNumber = cleanNumber.startsWith('0') ? `234${cleanNumber.slice(1)}` : cleanNumber;

    return (
        <a href={`https://wa.me/${intlNumber}?text=Hi%20BeautyByChancy!%20I'd%20like%20to%20enquire%20about%20your%20products.`}
            target="_blank" rel="noopener noreferrer"
            className="fixed bottom-20 md:bottom-6 right-4 z-40 bg-[#25D366] text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300"
            data-testid="whatsapp-button">
            <MessageCircle className="w-7 h-7" fill="white" />
        </a>
    );
}
